import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getActTypes, deleteActType } from "../api";

const ActTypeList1 = ({ id_c }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const loadData = async () => {
    const result = await getActTypes(id_c);
    setData(result);
  };

  useEffect(() => {
    loadData();
  }, [id_c]);

  if (!data) return <p>{t("MList1")}</p>;

  const handleEdit = (id_activity) => {
    navigate(`/activity-types/${id_activity}/edit`);
  };

  const handleDelete = async (id_activity) => {
    if (!window.confirm(t("¿Eliminar este registro?"))) return;
    await deleteActType(id_c, id_activity);
    await loadData();
  };

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/activity-types/new")}>
          {t("actType5") /* clave de i18n p/ “Nuevo tipo de actividad” */}
        </button>

        <table className="table5">
          <thead>
            <tr>
              <th>{t("actType2") /* ID Activity */}</th>
              <th>{t("actType3") /* Oper Active */}</th>
              <th>{t("actType4") /* Observations */}</th>
              <th colSpan={2}>{t("actType6")}</th>
            </tr>
          </thead>
          <tbody>
            {(data.types || []).map((act) => (
              <tr key={act.id_activity}>
                <td>{act.id_activity}</td>
                <td>{Number(act.oper_active) ? t("Sí") : t("No")}</td>
                <td>{act.observations || "-"}</td>
                <td>
                  <button className="button" onClick={() => handleEdit(act.id_activity)}>
                    {t("MList7")}
                  </button>
                  </td>
                  <td>
                  <button className="buttonDel" onClick={() => handleDelete(act.id_activity)}>
                    {t("MList8")}
                  </button>
                </td>
              </tr>
            ))}
            {(!data.types || data.types.length === 0) && (
              <tr>
                <td colSpan={4}>{t("Sin registros")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActTypeList1;
